
import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";

import styles from "./TableAndSearchMaster.module.scss";
import notificationService from "services/notification.service";

var tempSearchvalueStore;

export default function NewSearch(props) {
  const { tempSearch } = props;

  const [searchtValue, setSearchValue] = useState("");

  const setSearchBarData = (string) => {
    tempSearchvalueStore = string;
    localStorage.setItem("lastTableSearch", string);
    // setSearchValue(string);
    // if (string === "") return props.onSearch(props?.filter);
    setSearchValue(string);
    if (string === "") return props.onSearch();
  };

  useEffect(() => {
    localStorage.setItem("tableSearchTigger", "inActive");
  }, []);

  useEffect(() => {
    if (
      !tempSearch ||
      typeof tempSearch === "object" ||
      typeof tempSearch === "undefined" ||
      (typeof tempSearch === "string" && tempSearch?.trim().length === 0)
    ) {
      setSearchValue("");
    } else {
      const valueCheck = localStorage.getItem("lastTableSearch");
      console.log(valueCheck, "valueCheck");
      if (valueCheck) {
        tempSearchvalueStore = tempSearch;
      } else {
        tempSearchvalueStore = "";
      }
      setSearchValue(tempSearchvalueStore);
    }
  }, [tempSearch]);

  useEffect(() => {
    const valueCheck = localStorage.getItem("lastTableSearch");
    if (valueCheck) {
      tempSearchvalueStore = tempSearch;
    } else {
      tempSearchvalueStore = "";
    }
    setSearchValue(tempSearchvalueStore);
  }, []);

  const emptyErrorHandle = () => {
    const trimValue = searchtValue.trim();
    console.log(trimValue,"trimValue")
    const searchLength = trimValue.length;
    if (searchLength === 0) {
      notificationService.showNonBlacklistedError("", "Please enter search criteria.");
    }
  }

  const searchHandle = () => {
    localStorage.setItem("tableSearchTigger", "active");
    emptyErrorHandle();
    props.onSearch(searchtValue.trim());
  };

  return (
    <div className={cn(styles.block8, styles.block8_layout)}>
      <img
        src={require("assets/search.svg").default}
        onClick={(e) => {
          searchHandle(e);
          //  props?.onSearch(props?.filter,searchtValue)
          // //  props.setFilterAction([2, props.filterAction[1] == 0 ? 1 : 0]);
          props?.setFilterAction &&
            props?.setFilterAction([2, props?.filterAction[1] == 0 ? 1 : 0]);
        }}
        className={cn(styles.image_search_text)}
      />
      <input
        placeholder={props.placeholder}
        className={cn(styles.search_text)}
        onChange={(e) => {
          setSearchBarData(e.target.value);
          // props.setSearch &&  props.setSearch(e.target.value);
        }}
        value={tempSearchvalueStore}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            emptyErrorHandle()
            props.onSearch(searchtValue.trim());
            // props?.onSearch(props?.filter, searchtValue);
            localStorage.setItem("tableSearchTigger", "active");
            props?.setFilterAction &&
              props?.setFilterAction([2, props?.filterAction[1] == 0 ? 1 : 0]);
          }
        }}
      />
    </div>
  );
}
